module.exports = require('./lib/bezier');



//////////////////
// WEBPACK FOOTER
// ./~/bezier-js/index.js
// module id = 828
// module chunks = 0